import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  open,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) {
      document.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return createPortal(<AnimatePresence data-id="element-205" data-mp="1goqplr7bi7l">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title} data-id="element-206" data-mp="1hsloxffj7qaa">
          <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} data-id="element-207" data-mp="1fpjdklt795qd" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        duration: 0.2
      }} className="relative flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl" data-id="element-208" data-mp="1komje8h07fze">
            <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4" data-id="element-209" data-mp="11y4tscrgx0i9">
              <h2 className="font-display text-xl font-bold text-slate-900" data-id="element-210" data-mp="16ouwtjcf8r9s">{title}</h2>
              <button onClick={onClose} className="flex h-9 w-9 items-center justify-center rounded-full text-slate-500 transition-colors hover:bg-slate-100" aria-label="Close" data-id="element-211" data-mp="16qo7d9q5nvn2">
                <XIcon className="h-5 w-5" data-id="element-212" data-mp="e6pnk8wklz1q" />
              </button>
            </div>
            <div className="overflow-y-auto px-6 py-6 text-sm leading-relaxed text-slate-600" data-id="element-213" data-mp="66jlbg1wjvjv">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>, document.body);
}